// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9fc3174a","38":"6c1c1950","137":"454b4b23","239":"0c25a382","732":"8acfb5ef","904":"aba8e639","977":"9d9987bd"}[chunkId] + ".chunk.js";
};